import { Car, Counterparty, RepairType, Subdivision, User } from '~/shared/api'
import { repairOrderStatusEnumOptions } from '~/shared/config/constants'
import { Filter } from '~/shared/ui/AsyncGrid/types'

export const filters: Filter[] = [
  {
    field: 'number',
    label: 'filter.number',
    type: 'text',
  },
  {
    label: 'filter.date',
    type: 'dateRange',
    startField: 'createdAtGte',
    endField: 'createdAtLte',
  },
  {
    field: 'car',
    label: 'filter.car',
    type: 'autocomplete',
    fetchOptions: Car.fetchPlateNumberOptions,
  },
  {
    field: 'subdivision',
    label: 'column.subdivision',
    type: 'autocomplete',
    fetchOptions: Subdivision.fetchOptions,
  },
  {
    field: 'user',
    label: 'filter.user',
    type: 'autocomplete',
    fetchOptions: User.fetchOptions,
  },
  {
    field: 'status',
    label: 'filter.repair order status',
    type: 'select',
    options: repairOrderStatusEnumOptions,
  },
  {
    field: 'repairTypes',
    label: 'filter.repair type',
    type: 'autocomplete',
    fetchOptions: RepairType.fetchOptions,
  },
  {
    field: 'counterparty',
    label: 'filter.counterparty',
    type: 'autocomplete',
    fetchOptions: Counterparty.fetchOptions,
  },
  {
    field: 'materialsCost',
    label: 'filter.materials cost',
    type: 'price',
  },
  {
    field: 'workCost',
    label: 'filter.work cost',
    type: 'price',
  },
  {
    field: 'totalCost',
    label: 'filter.total cost',
    type: 'price',
  },
]
